import React, { useEffect, useState } from "react";
import { Card, Button, Typography, Tag, Row, Col, Modal, Spin, message } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import axios from "axios";
import { useLocation } from "react-router-dom";
import ProductDetail from "../Product/ProductDetail";
import Login from "../Login/Login";
import "../../config";

const { Title, Text, Paragraph } = Typography;

const ProductUpdates = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isModalVisible, setIsModalVisible] = useState(false);
    const [selectedProductId, setSelectedProductId] = useState(null);
    const [loginModalVisible, setLoginModalVisible] = useState(false);
    const location = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const data = searchParams.get("Data");

        if (data) {
            checkUserActiveStatus();
            fetchProducts(data);
            logUserActivity(data);
        } else {
            setLoading(false);
        }
    }, [location.search]);

    const checkUserActiveStatus = async () => {
        const tokenString = localStorage.getItem("token");
        if (!tokenString) {
            setLoginModalVisible(true);
            return;
        }

        try {
            let config = {
                method: "get",
                url: global.config.APIURL.BaseURL + "api/UserAccount/GetUserAccountDetail",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + tokenString,
                },
            };

            const response = await axios.request(config);
            if (
                response.data.IsActive === false ||
                response.data.IsDeleted === false ||
                response.data.IsEmployee !== true
            ) {
                // alert("You are not authorized to access this page."); // User might prefer modal over alert
                localStorage.removeItem("token");
                localStorage.removeItem("userName");
                setLoginModalVisible(true);
            }
        } catch (error) {
            if (error.response && error.response.status === 401) {
                localStorage.removeItem("token");
                setLoginModalVisible(true);
            }
        }
    };

    const logUserActivity = async (launchCode) => {
        const tokenString = localStorage.getItem("token");

        try {
            const jsondata = JSON.stringify({
                ScreenID: "1006",
                DetailID: launchCode || "0",
            });

            let config = {
                method: "post",
                url: global.config.APIURL.BaseURL + "api/UserActivity/InsertActivity",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + tokenString,
                },
                data: jsondata,
            };

            axios
                .request(config)
                .then((response) => { })
                .catch((error) => { });
        } catch (err) { }
    };

    const fetchProducts = async (data) => {
        try {
            const tokenString = localStorage.getItem("token");
            const config = {
                method: "get",
                url: global.config.APIURL.BaseURL + "api/NewLaunch/GetProductListforNewLaunchbyID?LaunchIDCode=" + data,
                headers: {
                    Authorization: "Bearer " + tokenString,
                },
            };

            const response = await axios.request(config);
            setProducts(response.data || []);
        } catch (error) {
            console.error("Error fetching launch products:", error);
            if (error.response && error.response.status === 401) {
                setLoginModalVisible(true);
            } else {
                message.error("Failed to load products.");
            }
        } finally {
            setLoading(false);
        }
    };

    const handleViewDetails = (productId) => {
        setSelectedProductId(productId);
        setIsModalVisible(true);
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedProductId(null);
    };

    const handleLoginSuccess = (token) => {
        setLoginModalVisible(false);
        // Re-fetch products after successful login
        const searchParams = new URLSearchParams(location.search);
        const data = searchParams.get("Data");
        if (data) {
            fetchProducts(data);
        }
    };

    const searchParams = new URLSearchParams(location.search);
    const mn = searchParams.get("mn"); // Get mobile number from URL

    return (
        <div
            style={{
                padding: "40px 20px",
                background: "linear-gradient(135deg, #fdfbfb 0%, #ebedee 100%)",
                minHeight: "100vh",
            }}
        >
            <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
                {/* Header Section */}
                <div style={{ textAlign: "center", marginBottom: "50px" }}>
                    <Title level={1} style={{ color: "#1a1a1a", marginBottom: "10px", fontFamily: "'Playfair Display', serif" }}>
                        New Launches
                    </Title>
                    <Paragraph style={{ fontSize: "18px", color: "#666", maxWidth: "600px", margin: "0 auto" }}>
                        Discover our latest collection of exquisite jewelry, crafted with passion and precision.
                    </Paragraph>
                </div>

                {/* Product Grid */}
                {loading ? (
                    <div style={{ textAlign: "center", padding: "50px" }}>
                        <Spin size="large" />
                    </div>
                ) : (
                    <Row gutter={[32, 32]}>
                        {products.map((product) => (
                            <Col xs={24} sm={12} lg={8} key={product.ProductID}>
                                <Card
                                    hoverable
                                    onClick={() => handleViewDetails(product.ProductID)}
                                    style={{
                                        borderRadius: "16px",
                                        overflow: "hidden",
                                        boxShadow: "0 10px 30px rgba(0,0,0,0.05)",
                                        border: "none",
                                        height: "100%",
                                        display: "flex",
                                        flexDirection: "column",
                                        transition: "all 0.3s ease",
                                        cursor: "pointer",
                                    }}
                                    cover={
                                        <div style={{ position: "relative", height: "300px", overflow: "hidden" }}>
                                            <img
                                                alt={product.ProductName}
                                                src={product.ImageUrl}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                    transition: "transform 0.5s ease",
                                                }}
                                                onMouseOver={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
                                                onMouseOut={(e) => (e.currentTarget.style.transform = "scale(1)")}
                                            />
                                            {product.Status && (
                                                <Tag
                                                    color={product.Status === "Available" ? "#52c41a" : "#f5222d"}
                                                    style={{
                                                        position: "absolute",
                                                        top: "15px",
                                                        right: "15px",
                                                        padding: "5px 10px",
                                                        fontSize: "12px",
                                                        fontWeight: "bold",
                                                        borderRadius: "20px",
                                                        border: "none",
                                                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                                    }}
                                                >
                                                    {product.Status}
                                                </Tag>
                                            )}
                                        </div>
                                    }
                                    bodyStyle={{ flex: 1, display: "flex", flexDirection: "column", padding: "24px" }}
                                >
                                    <div style={{ marginBottom: "auto" }}>
                                        <Title level={4} style={{ marginBottom: "8px", color: "#333" }}>
                                            {product.ProductName}
                                        </Title>
                                        <Text strong style={{ fontSize: "18px", color: "#d4af37", display: "block", marginBottom: "12px" }}>
                                            ₹{product.SalesRate ? product.SalesRate.toFixed(2) : "0.00"}
                                        </Text>
                                        <Paragraph ellipsis={{ rows: 2 }} style={{ color: "#777", marginBottom: "20px" }}>
                                            {product.DesignNo}
                                        </Paragraph>
                                    </div>

                                    <Button
                                        type="primary"
                                        size="large"
                                        icon={<ArrowRightOutlined />}
                                        onClick={() => handleViewDetails(product.ProductID)}
                                        style={{
                                            width: "100%",
                                            borderRadius: "8px",
                                            background: "#1a1a1a",
                                            borderColor: "#1a1a1a",
                                            height: "45px",
                                            fontWeight: "600",
                                        }}
                                        onMouseOver={(e) => {
                                            e.currentTarget.style.background = "#d4af37";
                                            e.currentTarget.style.borderColor = "#d4af37";
                                        }}
                                        onMouseOut={(e) => {
                                            e.currentTarget.style.background = "#1a1a1a";
                                            e.currentTarget.style.borderColor = "#1a1a1a";
                                        }}
                                    >
                                        View Details
                                    </Button>
                                </Card>
                            </Col>
                        ))}
                    </Row>
                )}
            </div>

            {/* Product Detail Modal */}
            <Modal
                open={isModalVisible}
                onCancel={handleCloseModal}
                footer={null}
                width={1000}
                centered
                destroyOnClose
            >
                {selectedProductId && (
                    <ProductDetail
                        productIdQuery={selectedProductId}
                        isModal={true}
                    />
                )}
            </Modal>

            {/* Login Modal */}
            <Modal
                open={loginModalVisible}
                onCancel={() => {
                    // Optional: Redirect to home or keep open? 
                    // User said "open loginpage in modalpopup", usually implies mandatory login for this page.
                    // But we can allow closing if they want to leave.
                    // For now, let's allow closing but maybe they can't see products.
                    setLoginModalVisible(false);
                }}
                footer={null}
                width={500}
                centered
                destroyOnClose
                closable={false} // Force login?
                maskClosable={false}
            >
                <Login
                    setToken={handleLoginSuccess}
                    urlParams={{
                        mob: mn,
                        fullPath: location.pathname,
                        searchParams: location.search
                    }}
                />
            </Modal>
        </div>
    );
};

export default ProductUpdates;
